module.exports = __webpack_public_path__ + "static/media/vivaticket.7b30766e.svg";